export default {"src":"https://s.sylndr.com/c-e456acf/_next/static/media/marker-pin.f61270d2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};